import React from 'react';
import PropTypes from 'prop-types';
import { VAN_WESTENDORP_QUESTION_ANSWER_TYPE_NUMERIC } from '../constants';
import InputNumericVanWestendorp from '../InputNumericVanWestendorp';

export default function MatrixVanWestendorpAnswer({
  answer,
  min,
  max,
  decimals,
}) {
  const { type, id: answerId } = answer;
  switch (type) {
    case VAN_WESTENDORP_QUESTION_ANSWER_TYPE_NUMERIC:
      return (
        <InputNumericVanWestendorp
          min={min}
          max={max}
          answerId={answerId}
          decimals={decimals}
        />
      );
    default:
      return (
        <InputNumericVanWestendorp
          min={min}
          max={max}
          answerId={answerId}
          decimals={decimals}
        />
      );
  }
}
MatrixVanWestendorpAnswer.propTypes = {
  answer: PropTypes.object,
  min: PropTypes.number,
  max: PropTypes.number,
  decimals: PropTypes.number,
};
